export default "__VITE_ASSET__DjRvSSY0__";